export class RedemptionBulkUpdateService {
  constructor($http) {
    this.$http = $http;
  }

  redeem(file) {
    const fd = new FormData();
    fd.append('attachment', file);
    return this.$http.post('oc-api/operations/redemptions/bulk_redeem', fd, {
      transformRequest: angular.identity,
      headers: {
        'Content-Type': undefined
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/redemptions/bulk-update/bulk-update.service.js